import _classCallCheck from 'E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck';
import _createClass from 'E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/createClass';
import _possibleConstructorReturn from 'E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from 'E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf';
import _inherits from 'E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/inherits';
/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module page-break/pagebreakediting
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import PageBreakCommand from './pagebreakcommand';
import { toWidget } from '@ckeditor/ckeditor5-widget/src/utils';
import first from '@ckeditor/ckeditor5-utils/src/first';
import '../theme/pagebreak.css';
/**
 * The page break editing feature.
 *
 * @extends module:core/plugin~Plugin
 */
var PageBreakEditing = /*#__PURE__*/
function (_Plugin) {
    _inherits(PageBreakEditing, _Plugin);
    function PageBreakEditing() {
        _classCallCheck(this, PageBreakEditing);
        return _possibleConstructorReturn(this, _getPrototypeOf(PageBreakEditing).apply(this, arguments));
    }
    _createClass(PageBreakEditing, [{
            key: 'init',
            /**
     * @inheritDoc
     */
            value: function init() {
                var editor = this.editor;
                var schema = editor.model.schema;
                var t = editor.t;
                var conversion = editor.conversion;
                schema.register('pageBreak', {
                    isObject: true,
                    allowWhere: '$block'
                });
                conversion.for('dataDowncast').elementToElement({
                    model: 'pageBreak',
                    view: function view(modelElement, viewWriter) {
                        var divElement = viewWriter.createContainerElement('div', {
                            class: 'page-break',
                            // If user has no `.ck-content` styles, it should always break a page during print.
                            style: 'page-break-after: always'
                        });
                        // For a rationale of using span inside a div see:
                        // https://github.com/ckeditor/ckeditor5-page-break/pull/1#discussion_r328934062.
                        var spanElement = viewWriter.createContainerElement('span', { style: 'display: none' });
                        viewWriter.insert(viewWriter.createPositionAt(divElement, 0), spanElement);
                        return divElement;
                    }
                });
                conversion.for('editingDowncast').elementToElement({
                    model: 'pageBreak',
                    view: function view(modelElement, viewWriter) {
                        var label = t('Page break');
                        var viewWrapper = viewWriter.createContainerElement('div');
                        var viewLabelElement = viewWriter.createContainerElement('span');
                        var innerText = viewWriter.createText(t('Page break'));
                        viewWriter.addClass('page-break', viewWrapper);
                        viewWriter.setCustomProperty('pageBreak', true, viewWrapper);
                        viewWriter.addClass('page-break__label', viewLabelElement);
                        viewWriter.insert(viewWriter.createPositionAt(viewWrapper, 0), viewLabelElement);
                        viewWriter.insert(viewWriter.createPositionAt(viewLabelElement, 0), innerText);
                        return toPageBreakWidget(viewWrapper, viewWriter, label);
                    }
                });
                conversion.for('upcast').elementToElement({
                    view: function view(element) {
                        // The "page break" div must have specified value for the 'page-break-after' definition and single child only.
                        if (!element.is('div') || element.getStyle('page-break-after') != 'always' || element.childCount != 1) {
                            return;
                        }
                        var viewSpan = first(element.getChildren());
                        // The child must be the "span" element that is not displayed and has a space inside.
                        if (!viewSpan.is('span') || viewSpan.getStyle('display') != 'none' || viewSpan.childCount != 1) {
                            return;
                        }
                        var text = first(viewSpan.getChildren());
                        if (!text.is('text') || text.data !== ' ') {
                            return;
                        }
                        return { name: true };
                    },
                    model: 'pageBreak'
                });
                editor.commands.add('pageBreak', new PageBreakCommand(editor));
            }
        }], [{
            key: 'pluginName',
            /**
     * @inheritDoc
     */
            get: function get() {
                return 'PageBreakEditing';
            }
        }]);
    return PageBreakEditing;
}(Plugin);
// Converts a given {@link module:engine/view/element~Element} to a page break widget:
// * Adds a {@link module:engine/view/element~Element#_setCustomProperty custom property} allowing to
//   recognize the page break widget element.
// * Calls the {@link module:widget/utils~toWidget} function with the proper element's label creator.
//
//  @param {module:engine/view/element~Element} viewElement
//  @param {module:engine/view/downcastwriter~DowncastWriter} writer An instance of the view writer.
//  @param {String} label The element's label.
//  @returns {module:engine/view/element~Element}
export {
    PageBreakEditing as default
};
function toPageBreakWidget(viewElement, writer, label) {
    writer.setCustomProperty('pageBreak', true, viewElement);
    return toWidget(viewElement, writer, { label: label });
}